import React, {useContext} from "react";
import {TimelineFrameContentLocationContext} from "./TimelineFrameContentLocationWrapper";
import {TYPE_FIMLAB, TYPE_GTI} from "../../../../../../definitions/TimelineItems";
import {FormattedMessage} from "react-intl";
import {OTLink} from "../../../../../../components/tag/OTLink";
import OTIcon from "../../../../../../components/tag/OTIcon";

let { id: module_id } = module;

export const TimelineFrameContentLocation = () => {
    const {department, type, link} = useContext(TimelineFrameContentLocationContext)

    switch(type) {
        case TYPE_FIMLAB:
            return (
                <p>
                    <FormattedMessage
                        id={`${module_id}.department.${TYPE_FIMLAB}`}
                        values={{
                            br: <br />,
                            a: (chunks) =>  <OTLink
                                target="_blank"
                                onClick={(e) => e.stopPropagation()}
                                link={"https://fimlab.fi/toimipisteet-ja-aukioloajat"}
                                isExternal={true}
                                className="card-link"
                            >{chunks}</OTLink>
                        }}
                    />
                    <OTIcon
                        style={{ padding: '2px' }}
                        config={{
                            type: 'fa',
                            name: 'icon-external-link',
                            color: 'blue',
                        }}
                    />
                </p>
            )
        default:
            if (link !== "") {
                return (
                  <FormattedMessage
                    id={`${module_id}.department.location`}
                    values={{
                      department: department.trimEnd(),
                      a: (chunks) => <OTLink
                        target="_blank"
                        onClick={(e) => e.stopPropagation()}
                        link={link}
                        className="card-link"
                        isExternal
                      >
                        {chunks}
                      </OTLink>
                    }}
                    />
                  )
            } else {
                return <p>{department}</p>
            }
    }
}